import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { blockCompany } from "../api/blockCompany";

export const useBlockCompany = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ companyId, body }) => blockCompany(companyId, body),
    onSuccess: () => {
      toast.success("Company blocked successfully!");
      queryClient.invalidateQueries({ queryKey: ["subscriptionDetails"] });
      queryClient.invalidateQueries({ queryKey: ["allSubscriptions"] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to block company.");
    },
  });
};

